import { useCallback, useContext } from "react";

import { ContextProviderProps, createContext, generateContextProvider } from "./context";

export type ErrorContext = {
  errorMessages: string[];
};

interface ErrorContextProviderProps extends ContextProviderProps {}

const errorReactContext = createContext<ErrorContext>();

export const useGetError = () => {
  const [context] = useContext(errorReactContext);
  return context;
};

export const useHandleErrorContext = () => {
  const [, setContext] = useContext(errorReactContext);
  return useCallback((error: ErrorContext) => setContext(error), [setContext]);
};

export const useHandleErrorMessage = () => {
  const handleErrorContext = useHandleErrorContext();
  return useCallback((error: string) => handleErrorContext({ errorMessages: [error] }), [handleErrorContext]);
};

export const useClearError = () => {
  const [, setContext] = useContext(errorReactContext);
  return useCallback(() => setContext(undefined), [setContext]);
};

export const ErrorContextProvider = generateContextProvider<ErrorContext, ErrorContextProviderProps>(errorReactContext);
